import { MutationResult, useApolloClient } from '@apollo/client';
import { useAuthToken } from './useAuthToken';
import { useHistory, useLocation } from 'react-router-dom';
import { useHeaLoginMutation } from '@src/api/graphql-codegen';
import { useState } from 'react';
import { useAnalytics, Events } from '@hooks';
import { logger } from '../utils/logger';

type UseLoginMutationResponse = [(email: string, password: string) => void, () => void, MutationResult];
export const useHsaLoginMutation = (): UseLoginMutationResponse => {
  const { setHsaAuthToken, removeHsaAuthToken, setAuthPassword, removeAuthPassword, setParentFirstLogin } = useAuthToken();
  const client = useApolloClient();
  const history = useHistory();
  const location = useLocation();
  const { identify, trackEvent, segment } = useAnalytics();
  const [password, setPassword] = useState('');

  const [loginMutation, mutationResults] = useHeaLoginMutation({
    onCompleted: (data) => {
      if (data.heaLogin.token) {
        setHsaAuthToken(data.heaLogin.token);
        setAuthPassword(password)
        setParentFirstLogin("YES");
        if (data.heaLogin.user?.id) {
          segment?.identify(data.heaLogin.user?.id);
          trackEvent(Events.actions.logIn, {
            loginType: 'Email',
            name: 'HEA Login',
            userId: data.heaLogin.user?.id,
          });
          identify(data.heaLogin.user?.id, {
            email: data.heaLogin.user.email,
          });
        }
        if (location.pathname === '/login' && history.length > 3 && location?.key && history.action !== 'POP') {
          history.goBack();
        } else {
          history.push('/studyplan');
        }
      }
    },
    onError: (error) => {
      logger.debug(`[Error]`, error);
    },
  });

  const login = (email: string, password: string) => {
    removeHsaAuthToken();
    setPassword(password);
    return loginMutation({
      variables: {
        input: {
          email,
          password
        }
      }
    });
  };

  const logout = async () => {
    await client.clearStore();
    trackEvent(Events.actions.logOut);
    removeHsaAuthToken();
    removeAuthPassword();
  };

  return [login, logout, mutationResults];
}
